
import React from 'react';
import './Footer.css';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import Shield from '../assets/images/bottom_logo.svg';

import SocialIcons from './SocialIcons';

export const Footer: React.FC<FooterProps> = () => {
  return <React.Fragment>
    <div className="footer">
      <div className="links">
        <a target="_blank" rel="noopener noreferrer" href="https://www.seabourn.com/en/us/cruise-destinations/expedition">Expeditions</a>
        <a target="_blank" rel="noopener noreferrer" href="https://www.seabourn.com/en/us/plan-a-cruise/post-booking/lead-sign-up">Special Offer</a>
      </div>
      <SocialIcons />
    </div>
    <div className="icon-container">
      <div className="bottom-logo-container">
        <svg width="50" height="1" fill="white" className="left-svg" >
          <rect width="50" height="1" />
        </svg>
        <img alt="Seabourn logo" src={Shield} onClick={()=>{window.open('https://www.seabourn.com','_blank');}} className="bottom-logo"/> 
        <svg width="50" height="1" fill="white" className="right-svg">
          <rect width="50" height="1" />
        </svg>
      </div>
    </div>
  </React.Fragment>;

};

const mapStateToProps = (state: RootState) => {
  return{

  };
};

const dispatchProps = {

};

type FooterProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(Footer);